
import Vue from 'vue'

const getDefaultState = () => {
    return {
        desconto: {
            id: 0,
            tipo: "",
            idTable: 0,
            tipoCliente: 1,
            qtdePecasLimite: 0,
            desconto: 0
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("comum/desconto/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listDescontos = result.data.result;

                return listDescontos;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar os descontos: [${ex}]`
            };
        }
    },

    async ListPaged(_, descontoFilter) {

        try {
            const result = await Vue.prototype.$spTechApi.post("comum/desconto/list-paged", descontoFilter,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data && result.data.result) {
                return result.data.result;
            }

            return {
                items: [],
                totalItems: 0,
                page: descontoFilter.page || 1,
                pageSize: descontoFilter.pageSize || 10
            };
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar os descontos: [${ex}]`,
                items: [],
                totalItems: 0,
                page: descontoFilter.page || 1,
                pageSize: descontoFilter.pageSize || 10
            };
        }
    },

    async ListTipoClienteProduto(_, descontoFilter) {

        try {
            const result = await Vue.prototype.$spTechApi.post("comum/desconto/list-tipocliente-produto", descontoFilter,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listDescontos = result.data.result;

                return listDescontos;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar os descontos: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`comum/desconto/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter o desconto`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter o desconto: [${ex}]`
            };
        }
    },

    async Create(_, descontoRequest) {

        try {
            const result = await Vue.prototype.$spTechApi.post(`comum/desconto/create`, descontoRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Registro criado com sucesso!";

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Erro ao criar o registro!"
                };
            }
        }
        catch(error) {

            console.log('error', error)

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Erro ao criar o registro: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Erro ao criar o registro: [${error}]`
                };
            }
        }
    },

    async Update(_, descontoRequest) {

        try {
            const result = await Vue.prototype.$spTechApi.put(`comum/desconto/update/${descontoRequest.id}`, descontoRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                const msg = "Registro atualizado com sucesso!";

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Erro ao atualizar o registro!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Erro ao atualizar o registro: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Erro ao atualizar o registro: [${error}]`
                };
            }
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.delete(`comum/desconto/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Registro excluído com sucesso!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Erro ao excluir registro: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Erro ao excluir registro: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.desconto, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.desconto;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
